<template>
    <div class="row faq-container align-items-center mb-3">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12">
                <label class="form-label mb-1">Description générale</label>
                <div ref="editor"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            editorInstance: null,
            localDescription: this.value,
        }
    },
    watch: {
        value(newValue) {
            if (this.editorInstance && newValue !== this.editorInstance.getData()) {
                this.editorInstance.setData(newValue)
            }
        },
    },
    mounted() {
        this.initializeEditor()
    },
    beforeDestroy() {
        if (this.editorInstance) {
            this.editorInstance.destroy().catch((error) => console.error('Error destroying editor:', error))
        }
    },
    methods: {
        initializeEditor() {
            ClassicEditor.create(this.$refs.editor, {
                toolbar: [
                    'heading',
                    '|',
                    'bold',
                    'italic',
                    'underline',
                    'strikethrough',
                    '|',
                    'link',
                    'blockQuote',
                    '|',
                    'bulletedList',
                    'numberedList',
                    '|',
                    'insertTable',
                    'imageUpload',
                    '|',
                    'undo',
                    'redo',
                    '|',
                    'alignment:left',
                    'alignment:center',
                    'alignment:right',
                    'alignment:justify',
                    '|',
                    'fontSize',
                    'fontColor',
                    'fontBackgroundColor',
                    '|',
                    'highlight',
                    'removeFormat',
                ],
                language: 'fr',
                image: {
                    toolbar: ['imageTextAlternative', 'imageStyle:full', 'imageStyle:side'],
                    styles: ['full', 'side'],
                    upload: {
                        types: ['jpeg', 'png', 'gif', 'bmp', 'webp', 'tiff'],
                    },
                },
                table: {
                    contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
                },
                fontSize: {
                    options: [9, 11, 13, 'default', 17, 19, 21],
                    supportAllValues: false,
                },
                fontColor: {
                    columns: 5,
                    documentColors: 10,
                },
                fontBackgroundColor: {
                    columns: 5,
                    documentColors: 10,
                },
                heading: {
                    options: [
                        { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
                        { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
                        { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
                        { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
                    ],
                },
                alignment: {
                    options: ['left', 'center', 'right', 'justify'],
                },
                link: {
                    decorators: {
                        addTargetToExternalLinks: true,
                        defaultProtocol: 'https://',
                        openInNewTab: true,
                    },
                },
                placeholder: 'Tapez votre description générale ici...',
                // Plugins
                removePlugins: ['MediaEmbed'],
                extraPlugins: [], // extra plugins if needed
                licenseKey: '', // license key if you're using a commercial CKEditor version
                placeholder: 'Tapez votre description générale ici...',
            })
                .then((editor) => {
                    this.editorInstance = editor
                    editor.setData(this.localDescription)
                    editor.model.document.on('change:data', () => {
                        const data = editor.getData()
                        this.$emit('input', data)
                    })
                })
                .catch((error) => {
                    console.error('There was a problem initializing CKEditor:', error)
                })
        },
    },
}
</script>

<style scoped></style>
